var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBilling(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "article"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 4.16679V15.8335H4.16667V4.16679H15.8333ZM15.8333 2.50012H4.16667C3.25 2.50012 2.5 3.25012 2.5 4.16679V15.8335C2.5 16.7501 3.25 17.5001 4.16667 17.5001H15.8333C16.75 17.5001 17.5 16.7501 17.5 15.8335V4.16679C17.5 3.25012 16.75 2.50012 15.8333 2.50012Z",
    fill: "#676E85"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6667 14.1668H5.83333V12.5001H11.6667V14.1668ZM14.1667 10.8335H5.83333V9.16679H14.1667V10.8335ZM14.1667 7.50012H5.83333V5.83346H14.1667V7.50012Z",
    fill: "#676E85"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBilling);
export default __webpack_public_path__ + "static/media/billing.8118b2504f421608bcc4ed9c2607bf7d.svg";
export { ForwardRef as ReactComponent };